import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { AppState } from './store'

interface BrukareFilterState {
  data: any
  deselectedColumns: string[]
}

const initialState: BrukareFilterState = {
  data: undefined,
  deselectedColumns: ['Period'],
}

const brukareFilterSlice = createSlice({
  name: 'brukareFilter',
  initialState,
  reducers: {
    setBrukareFilter(state, action: PayloadAction<{ data: any }>) {
      state.data = action.payload.data
    },
    setBrukareDeselectedColumns(state, action: PayloadAction<string[]>) {
      state.deselectedColumns = action.payload
    },
  },
})

export const getBrukareFilter = (state: AppState) => state.brukareFilterReducer.data
export const getBrukareDeselectedColumns = (state: AppState) => state.brukareFilterReducer.deselectedColumns
export const { setBrukareFilter, setBrukareDeselectedColumns } = brukareFilterSlice.actions
export default brukareFilterSlice.reducer
